import React from 'react';

export default function AutomationExecutions({ executions }) {
  return (
    <div className="md:col-span-2 mt-6 pt-6 border-t border-gray-200 mr-6">
      <h3 className="text-lg font-medium text-gray-900 mb-4"> ביצועי אוטומציות</h3>

      {executions.length > 0 ? (
        <div className="space-y-3">
          {executions.map((execution) => (
            <div key={execution.id} className="bg-gray-50 rounded-lg p-4 border border-gray-200">
              <div className="grid grid-cols-2 md:grid-cols-5 gap-3 text-sm">
                <div>
                  <span className="font-medium text-gray-700">שם אוטומציה:</span>
                  <p className="text-gray-900">{execution.automationName || 'לא ידוע'}</p>
                </div>

                <div>
                  <span className="font-medium text-gray-700">סוג טריגר:</span>
                  <p className="text-gray-900">
                    {execution.triggerType === 'before_appointment' && 'לפני תור'}
                    {execution.triggerType === 'after_appointment' && 'אחרי תור'}
                    {execution.triggerType === 'appointment_created' && 'כאשר נוצר'}
                    {execution.triggerType === 'appointment_approved' && 'באישור תור'}
                    {!['before_appointment', 'after_appointment', 'appointment_created', 'appointment_approved'].includes(execution.triggerType) && execution.triggerType}
                  </p>
                </div>

                <div>
                  <span className="font-medium text-gray-700">הושלם ב:</span>
                  <p className="text-gray-900">
                    {execution.completedAt ? new Date(execution.completedAt).toLocaleString('he-IL') : 'לא זמין'}
                  </p>
                </div>

                <div>
                  <span className="font-medium text-gray-700">סטטוס משלוח:</span>
                  <p className="text-gray-900">
                    {execution.deliveryStatus === 'delivered' && 'נמסר'}
                    {execution.deliveryStatus === 'failed' && 'נכשל'}
                    {execution.deliveryStatus === 'pending' && 'ממתין'}
                    {!execution.deliveryStatus && 'לא זמין'}
                  </p>
                </div>

                <div>
                  <span className="font-medium text-gray-700">סטטוס:</span>
                  <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${execution.status === 'completed' ? 'bg-green-100 text-green-800' :
                    execution.status === 'failed' ? 'bg-red-100 text-red-800' :
                      execution.status === 'pending' ? 'bg-yellow-100 text-yellow-800' :
                        'bg-gray-100 text-gray-800'
                    }`}>
                    {execution.status === 'completed' && 'הושלם'}
                    {execution.status === 'failed' && 'נכשל'}
                    {execution.status === 'pending' && 'ממתין'}
                    {execution.status === 'executing' && 'בביצוע'}
                    {!['completed', 'failed', 'pending', 'executing'].includes(execution.status) && execution.status}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-6 text-gray-500">
          <p>לא פעלו אוטומציות עבור התור הזה עדיין</p>
        </div>
      )}
    </div>
  );
}
